import { generateRecaptchaToken } from './es6/utils.js';

$(document).ready(function() {

	function setCSRFheaders() {
		const csrf_token = $('meta[name="Csrf-Token"]').attr('content');

		if (csrf_token) {
			function csrfSafeMethod(method) {
				// these HTTP methods do not require CSRF protection
				return (/^(GET|HEAD|OPTIONS)$/.test(method));
			}

			$.ajaxSetup({
				beforeSend: function(xhr, settings) {
					if (!csrfSafeMethod(settings.type) && !this.crossDomain) {
						xhr.setRequestHeader("Csrf-Token", csrf_token);
					}
				}
			});
		}
	}

	setCSRFheaders();

    generateRecaptchaToken("oauth_popup");

	/* VALIDATE EMAIL */
	function isValidEmailAddress(emailAddress) {
		var pattern = new RegExp(/^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?$/i);
		return pattern.test(emailAddress);
	}

	/* GENERAL ERROR INFO SUCCESS MESSAGE */
	function generalInfo(showHide, type, message) {
		"use strict";

		if (showHide === 'hide') {

		$('.alert').remove();

		} else if (showHide && type && message) {

	    $("html, body").animate({
        scrollTop: 0
        }, 0);

		$('aside#alerts').html('<p class="alert '+type+' dynamic">'+message+'</p>');

		}


	}

	/* VALIDATE FORM FIELDS FUNCTION */
	function validateFormFields(form) {
		'use strict';

		var error;

		$(form).find('[data-validate="required"]:visible').each(function() {

			if (!$(this).val()) {
			$(this).addClass('error');
			error = true;
			} else {
			$(this).removeClass('error');
			}

		});

		$(form).find('[data-validate="email"]:visible').each(function() {

			if (!isValidEmailAddress($(this).val())) {
			$(this).addClass('error');
			error = true;
			} else {
			$(this).removeClass('error');
			}

		});

		if (error === true) {

			generalInfo('show', 'error', 'There were errors. Please amend all required fields and try again.');
			return false;

		} else {

			generalInfo('hide');

		}

		return true;

	}

	/* OAUTH QUICK SIGN UP INDIVIDUAL CHECKBOX */
	$('body').on('change', '[name="individual"]', function() {
		"use strict";

		$('[name="quick_signup_various[business_name]"]').val('');

		if ($(this).prop('checked') === true) {
		$('[name="quick_signup_various[business_name]"]').addClass('disabled');
		$('[name="quick_signup_various[business_name]"]').attr('disabled', 'disabled');
		} else {
		$('[name="quick_signup_various[business_name]"]').removeAttr('disabled');
		$('[name="quick_signup_various[business_name]"]').removeClass('disabled');
		}

	});


	/* OAUTH QUICK SIGN UP */
	$('body').on('submit', '[name="quick_signup_various"]', function(event) {

		event.preventDefault();

		var button = $(this).find('[data-loading="true"]');
		button.removeClass('loading');

		generalInfo('hide');

		var emailInput = $(this).find('[name="quick_signup_various[email]"]');
		var firstNameInput = $(this).find('[name="quick_signup_various[first_name]"]');
		var lastNameInput = $(this).find('[name="quick_signup_various[last_name]"]');
		var passwordInput = $(this).find('[name="quick_signup_various[password]"]');
		var businessNameInput = $(this).find('[name="quick_signup_various[business_name]"]');
		var vanityURLInput = $(this).find('[name="quick_signup_various[vanity_url]"]');
		const vanityURLInputVal = vanityURLInput.val();
		const businessIdentifierMinLen = 3;
		const businessIdentifierMaxLen = 50;

		var error = false;

		if(!validateFormFields($(this))) {
			error = true;
		}

		if (!passwordInput.val()) {

			error = true;
			passwordInput.addClass('error');

		} else {

			if (passwordInput.val().length < 6) {
			passwordInput.closest('.form_row').find('span.error').html('Minimum 6 characters');
			passwordInput.addClass('error');
			} else {
			passwordInput.closest('.form_row').find('span.error').html('');
			passwordInput.removeClass('error');
			}

		}

		if (!isValidEmailAddress(emailInput.val())) {
			error = true;
			emailInput.addClass('error');
		} else {
			emailInput.removeClass('error');
		}

		if (!vanityURLInputVal) {
			error = true;
			vanityURLInput.addClass('error');
		} else {

			$('span.info.dynamic').html('Your Xodo Sign URL');
			$('[name="quick_signup_various[vanity_url]"]').removeClass('error');

			if (/^[a-zA-Z0-9]+$/.test(vanityURLInputVal) == false) {
				error = true;
				$('[name="quick_signup_various[vanity_url]"]').addClass('error');
				$('span.info.dynamic').html('No special characters allowed');

			} else {

				if (vanityURLInputVal.length < businessIdentifierMinLen || vanityURLInputVal.length > businessIdentifierMaxLen) {
                    error = true;
                    $('[name="quick_signup_various[vanity_url]"]').addClass('error');
                    $('span.info.dynamic').html(`Between ${businessIdentifierMinLen} and ${businessIdentifierMaxLen} characters`);
				}

			}

		}

		if (!businessNameInput.val() && $('[name="individual"]').prop('checked') !== true) {
			error = true;
			businessNameInput.addClass('error');
		} else {
			businessNameInput.removeClass('error');
		}

		if (error === true) {
		return false;
		}

		button.addClass('loading');

        const captchaToken = $('[name="recaptcha_token"]').val();

		// build POST array
		var postData = {
			plan_id: 47, // free plan
			first_name: firstNameInput.val(),
			last_name: lastNameInput.val(),
			email_address: emailInput.val(),
			password: passwordInput.val(),
			business_name: businessNameInput.val(),
			business_vanity_name: vanityURLInput.val(),
			tos_accepted: 1,
			no_business: $('[name="individual"]').prop('checked') === true ? 1 : 0,
			quick_signup: 1,
            token: captchaToken,
		};

		var postDataJSON = JSON.stringify(postData);
		console.log(postDataJSON);

		$.ajax({
			type: "POST",
			url: '/php/public_ajax_handler.php?type=create_account',
			data: ({ postArray: postDataJSON }),
			dataType: "json",
			error: function(XMLHttpRequest, textStatus, errorThrown) {
				//alert(textStatus + ', ' + errorThrown);

                generateRecaptchaToken("oauth_popup_create_account_error");
			},
			success: function(data){

				if (data.success === 1) {

					generalInfo('show', 'success', 'Redirecting ...');

					var paramClientID = $('body').find('[name="client_id"]').val();
					var paramState = $('body').find('[name="state"]').val();

					var redirectURL = 'https://eversign.com/oauth/authorize?client_id='+paramClientID+'&state='+paramState;

					// log user in via perform_login and then redirect accordingly
					window.location.href = '/perform_login?email_address='+encodeURIComponent(emailInput.val())+'&one_time_signin_key='+data.message.one_time_signin_key+'&redirect_url='+encodeURIComponent(redirectURL);

					return false;

				} else {

                    generateRecaptchaToken("oauth_popup_create_account_data_success_false");

					generalInfo('show', 'error', data.message);

				}

				button.removeClass('loading');

			}

		});


	});


	/* OAUTH LOG IN */
	$('body').on('submit', '[name="oauth_login"]', function(event) {

		event.preventDefault();

		var button = $(this).find('[data-loading="true"]');
		button.removeClass('loading');

		generalInfo('hide');

		if(!validateFormFields($(this))) {
		return false;
		}

		button.addClass('loading');

        const captchaToken = $('[name="recaptcha_token"]').val();

		// build POST array
		var postData = {
			email_address: $(this).find('[name="oauth_login_email"]').val(),
			password: $(this).find('[name="oauth_login_password"]').val(),
            recaptcha_token: captchaToken,
		};

		var postDataJSON = JSON.stringify(postData);
		console.log(postDataJSON);

		$.ajax({
			type: "POST",
			url: '/php/public_ajax_handler.php?type=sign_in',
			data: ({ postArray: postDataJSON }),
			dataType: "json",
			error: function(XMLHttpRequest, textStatus, errorThrown) {
				//alert(textStatus + ', ' + errorThrown);

                generateRecaptchaToken("oauth_popup_sign_in_error");
			},
			success: function(data){

				console.log(data);

				if (data.success === 1) {

					generalInfo('show', 'success', 'Redirecting ...');

					location.reload();
					return false;

				} else {

					generateRecaptchaToken("oauth_popup_sign_in_success_false");

					generalInfo('show', 'error', 'Login failed. Please review your email address and password and try again.');

				}

				button.removeClass('loading');

			}

		});


	});


	/* OAUTH AUTHORIZE */
	$('body').on('click', '[data-oauth-action]', function(event) {

		var oauthAction = $(this).attr('data-oauth-action');

		event.preventDefault();

		var button = $(this);
		button.addClass('loading');

		// build POST array
		var postData = {
			sid: $('body').find('[name="oauth_session_id"]').val(),
			approval_action: oauthAction,
		};

		var postDataJSON = JSON.stringify(postData);
		console.log(postDataJSON);

		$.ajax({
			type: "POST",
			url: '/php/advanced_ajax_handler.php?type=oauth_perform_authorization',
			data: ({ postArray: postDataJSON }),
			dataType: "json",
			error: function(XMLHttpRequest, textStatus, errorThrown) {
				//alert(textStatus + ', ' + errorThrown);
			},
			success: function(data){

				if (data.success === 1) {

					window.location.href = data.message.redirect_url;
					return false;

				} else {

					generalInfo('show', 'error', data.message);

				}

				button.removeClass('loading');

			}

		});

	});


	/* OAUTH LOGOUT BUTTON */
	$('body').on('click', '[data-logout="true"]', function(event) {

		var postDataJSON = '';

		$.ajax({
			type: "POST",
			url: '/php/public_ajax_handler.php?type=sign_out',
			data: ({ postArray: postDataJSON }),
			dataType: "json",
			error: function(XMLHttpRequest, textStatus, errorThrown) {
				//alert(textStatus + ', ' + errorThrown);
			},
			success: function(data){

				if (data.success === 1) {

					generalInfo('show', 'success', 'Redirecting ...');

					location.reload();
					return false;

				} else {

					generalInfo('show', 'error', data.message);

				}

				button.removeClass('loading');

			}

		});


	});


















});

